import { combineReducers } from 'redux';

import auth from './authReducer.js';
import balance from './balancyReducer.js';
import birthday from './birthdaysReducer.js';
import calendar from './calendarReducer.js';
import debug from './debugReducer.js';
import emailTemplates from './emailTemplatesReducer.js';
import general from './generalReducer.js';
import holiday from './holidaysReducer.js';
import overtimesStatistics from './overtimesStatisticsReducer.js';
import pendingRequests from './pendingRequestsReducer.js';
import remoteCalendar from './remoteCalendarReducer.js';
import settings from './settingsReducer.js';
import sickLeave from './sickLeavesReducer.js';
import sickLeaveStatistics from './sickLeaveStatisticsReducer.js';
import team from './teamReducer.js';
import timeSheet from './timeSheetReducer.js';
import user from './userReducer.js';
import users from './usersReducer.js';
import userStatistics from './userStatisticsReducer.js';
import vacation from './vacationReducer.js';
import workingDay from './workingDayReducer.js';
import workingTime from './workingTimeReducer.js';
import workingTimeStatistics from './workingTimeStatisticsReducer.js';
import googleCalendar from './googleCalendarReducer.js';

export default function createRootReducer(routerReducer) {
    return combineReducers({
        router: routerReducer,
        general,
        overtimesStatistics,
        vacation,
        user,
        sickLeave,
        workingDay,
        holiday,
        birthday,
        balance,
        auth,
        workingTime,
        calendar,
        pendingRequests,
        timeSheet,
        sickLeaveStatistics,
        workingTimeStatistics,
        team,
        remoteCalendar,
        users,
        userStatistics,
        debug,
        settings,
        emailTemplates,
        googleCalendar,
    });
}
